import { render, staticRenderFns } from "./EditOrganisation.vue?vue&type=template&id=60d33f4c&"
import script from "./EditOrganisation.vue?vue&type=script&lang=js&"
export * from "./EditOrganisation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports